import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import * as compose from 'lodash.flowright';
import { gql } from 'apollo-boost';
import { Link } from 'react-router-dom';
import Loader from 'react-loader-spinner';
// styles images ad icons
import { Row, Col, Modal, ListGroup } from 'react-bootstrap';
import { Button, Chip } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen, faUserFriends } from '@fortawesome/free-solid-svg-icons'
import ShareIcon from '@material-ui/icons/Share';
import bookmark from '../../../images/border-bookmark.png';
import business from '../../../images/business-placeholder.png';
import more from '../../../images/more.svg';

class SearchResultCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading : false
        }
    }
    modelContent = () => {
        return (
            <Row className="m-0">
                <Col md={12} className="p-2">
                    <div className=" p-2 m-0 ">
                        <Row className="m-0 border rounded align-items-center justify-content-center p-2 w-100" >
                            <Col className="p-0" md={1} xs={3}>
                                <img 
                                    className="rounded-circle img-fluid"
                                    src={this.state.selectedJob.company.logo ? this.state.selectedJob.company.logo.url : business} 
                                    alt="company logo" />
                            </Col>
                            <Col  md={6} xs={9}>
                                <h5 className="text-dark mb-0">{this.state.selectedJob.title}</h5>
                                <p className="text-orange mb-0"><span classname="text-gray">by </span>{this.state.selectedJob.company.name}</p>
                                <p className="text-grey d-inline-block">{this.state.selectedJob.created_at}</p>
                            </Col>
                            <Col className="text-right" md={5} xs={12}>
                                    <Button 
                                        onClick={e=>this.handleApply(this.state.selectedJob.id )} 
                                        size="large" 
                                        className="btn-orange-gradiant pr-4 pl-4">Apply</Button>
                                <Button size="alrge"  className="pt-3 pb-3">
                                    <img src={more} alt="more" />
                                </Button>
                            </Col>
                        </Row>
                    </div>
                    <Row className="align-items-top m-0">
                        <Col  xs={12} className="w-100 text-left">
                            <h5 className="captialize">Job Description</h5>
                            <p className="text-orange d-inline-block pr-1 m-0">{this.state.selectedJob.company ? this.state.selectedJob.company.name : ''}</p>
                            <p>{this.state.selectedJob.brif && this.state.selectedJob.brif}</p>
                        </Col>
                    </Row>
                    <Row className="pt-1 m-0">
                        <Col xs={4} className="text-left mb-1 text-center-sm">
                            <FontAwesomeIcon icon={faUserFriends} size="lg" className="text-dark" />
                            <span className="pl-1">{this.state.selectedJob.applications_count + ' Applicant'}</span>
                        </Col>
                        <Col xs={4} className="text-left mb-1 text-center-sm">
                            <FontAwesomeIcon icon={faBoxOpen} size="lg" className="text-dark" />
                            <span className="pl-1">{this.state.selectedJob.questions && this.state.selectedJob.questions.length + ' Question'}</span>
                        </Col>
                        <Col xs={12} className="text-left mb-1 mt-2">
                            <p className="p-0 mb-1 bold">{ this.state.selectedJob.tags && 'Tags'}</p>
                            {this.state.selectedJob.tags?.map(tag =>
                                <Chip className="m-1" key={tag.name} label={tag.name} />
                            )}
                        </Col>
                        <Col xs={12} className="text-left">
                            {this.state.selectedJob.questions.length > 0 && <p className="p-0 mb-2 bold">Questions</p>}
                            <ListGroup>
                                {this.state.selectedJob.questions?.map((question, index) =>
                                    <ListGroup.Item style={{ width: 'fit-content' }} key={question.title} className="mb-2 border p-1 bg-lightgrey">{index + 1 + '- ' + question.title}</ListGroup.Item>
                                )}
                            </ListGroup>
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    }
    handleApply = (id ) => {
        this.setState({...this.state , loading : true})
        this.props.applyJob({
            variables: {
                "id": id
            }
        }).then((res ,loading) => {
            if(res.data.jobApply.Status.code === 200){

                this.setState({...this.state , loading : false})
                window.scrollTo({top : 0 , behavior : 'smooth'});
                this.props.history.push({
                    pathname : '/jobApply',
                    state : res.data.jobApply.Application
                })
            }
        }).catch((err) => 
            console.log(err)
        )
    }
    handleShow = (data) =>{
        this.setState({...this.state ,  selectedJob : data , show : true })
    }
    handleClose = () => {
        this.setState({...this.state , show : false })
    }
    render() {
        let jobs = this.props.data
        return (
            <div className="pt-4 pb-4 border-bottom w-100">
                <div >
                    <Loader
                        className="loading"
                        visible={this.state.loading}
                        type="TailSpin"
                        color="white"
                        height={50}
                        width={50}
                    />
                </div>
                {jobs?.map(job =>
                    <Row className="justify-content-center align-items-center m-0">
                        <Col md={1} xs={6} className="order-sm-1 order-2 text-center pr-1 pl-1 ">
                             <button 
                                    className="bg-transparent border-0 " 
                                    onClick={e => this.handleShow(job)}>
                                 <img 
                                    src={job.company.logo?job.company.logo.url : business} 
                                    alt="company logo" 
                                    className="rounded w-100 text-left mb-3" />
                            </button>
                        </Col>
                        <Col md={11} xs={12} className="order-sm-2 order-3 text-left">
                            <Row className="m-0">
                                <Col md='8' className="order-sm-1 order-2 p-0  d-inline-block">
                                    <button 
                                        className="bg-transparent border-0 text-left" 
                                        onClick={e => this.handleShow(job)}>
                                        <h5>{job.title}</h5>
                                        <p className="text-orange d-inline-block pr-1">{job.company.name}</p>
                                        <p>{job.brif && job.brif.length > 191 ? 
                                            <div>{job.brif.substring(0,191)}
                                                <button  
                                                className="bg-transparent border-0 text-orange underline"
                                                onClick={e => this.handleShow(job)}
                                                > See More</button></div> 
                                            : job.brif }
                                        </p>
                                    </button>
                                </Col>
                                <Col md='4' className="text-right order-sm-2 p-0 order-1 mb-1 d-inline-block text-responsive-right">
                                    {/* <Button size="large" variant="outlined" className="btn-orange-outline-gradiant" color="primary">
                                        <ShareIcon /> share
                                    </Button> */}
                                    <Link className="pl-3">
                                        <img src={bookmark} className="btn-bookmark" width="20" alt="bookmark" />
                                    </Link>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                )}
                {this.state.selectedJob &&
                    <Modal
                        size="lg"
                        className="row m-0  pr-0"
                        show={this.state.show} onHide={this.handleClose}>
                        <Col xs={12} className="p-0">
                            <Modal.Header className=" p-0 bg-lightgrey row m-0">
                                <Modal.Title className="h5 col-8 p-2 pr-3 pl-3 captialize" >{this.state.selectedJob.title}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="p-0">
                                <div key={this.state.selectedJob.id}>
                                    {this.modelContent()}
                                </div>
                            </Modal.Body>
                        </Col>
                    </Modal>
                }
            </div>
        );
    }
}

const APPLY_JOB = gql`
mutation( $id : Int){
    jobApply(Inputs: {
      id : $id
    }){
      Status{
        code
        message
      }
      Application{
        id
        user{
          id
          name
          email
        }
        answered_by{
          name
          email
        }
        bio{
            id
            speciality{
              name
            }
            completed{
              name
            }
            title
            brif
            tags
            video{
              url
              poster{
                url
              }
            }
            share_able_link
            has_application
            is_Draft
            is_my_profile_visume
            created_at
            updated_at
            bioTagsNames
            questions{
                id
              title
              ordering
            }
            videos{
              frame{
                url
              }
              poster{
                url
              }
            }
          }
        company{
          id
          name
          website_url
          description
          logo{url}
           
        }
      }
    }
  }
  
  
`

export default compose(
    graphql(APPLY_JOB, {
        name: "applyJob"
    })
)(withRouter(SearchResultCard));